import { render, staticRenderFns } from "./parkPage.vue?vue&type=template&id=510b7880"
import script from "./parkPage.vue?vue&type=script&lang=js"
export * from "./parkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports